import { TFormValues, TRequestValues } from '../../../types/requestDemand';
import { ERequestDemandField, EUserType } from '../../../constants/requestDemand';

export const getFormInitialState = (props: TRequestValues): TFormValues => ({
  [ERequestDemandField.EMAIL]: {
    value: props[ERequestDemandField.EMAIL] || '',
    isError: false,
  },
  [ERequestDemandField.PHONE]: {
    value: props[ERequestDemandField.PHONE] || '',
    isError: false,
  },
  [ERequestDemandField.USER_TYPE]: {
    value: props[ERequestDemandField.USER_TYPE] || EUserType.HOME_OWNER,
    isError: false,
  },
});
